import ListAgent from '../agent/list-agent';

// const icons = {
//   chat: "mdi:chat",
//   edit: "mdi:pencil",
//   delete: "mdi:trash",
// };

// interface Agent {
//   id: string;
//   name: string;
//   description: string;
//   isActive: boolean;
//   prompt?: string;
// }

export default function Admin() {
  return <ListAgent />;
}
